export default __webpack_public_path__ + "static/media/nogonew.1b262477.svg";